export default __webpack_public_path__ + "assets/slide-3.1ec963d8.png";